import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from '../config/config.service';
import {
  PushNotificationPayload,
  PushSubscriptionRequest,
} from './push-notification.model';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  private readonly swPush = inject(SwPush);
  private readonly http = inject(HttpClient);
  private readonly configService = inject(ConfigService);

  private readonly notifierApiUrl = computed(
    () => this.configService.config()?.apiUrls.notifierApi ?? null,
  );

  async requestAndSubscribe(): Promise<void> {
    console.log('[Push] requestAndSubscribe called');
    console.log('[Push] swPush.isEnabled:', this.swPush.isEnabled);
    console.log('[Push] Notification.permission:', Notification.permission);
    console.log('[Push] config:', this.configService.config());

    if (!this.swPush.isEnabled) {
      console.warn('[Push] SwPush is not enabled');
      return;
    }

    const publicKey = this.configService.config()?.pushNotificationPublicKey;

    if (!publicKey) {
      console.warn('[Push] Missing public key');
      return;
    }

    console.log('[Push] Requesting subscription...');

    const subscription = await this.swPush.requestSubscription({
      serverPublicKey: publicKey,
    });

    console.log('[Push] Subscription created:', subscription);

    const json = subscription.toJSON();

    const request: PushSubscriptionRequest = {
      endpoint: json.endpoint!,
      expirationTime: json.expirationTime ?? null,
      keys: {
        p256dh: json.keys!['p256dh'],
        auth: json.keys!['auth'],
      },
      deviceInfo: navigator.userAgent,
    };

    console.log('[Push] Sending subscription to API:', request);

    await firstValueFrom(
      this.http.post(
        `${this.notifierApiUrl()}/Notifications/subscribe`,
        request,
      ),
    );

    console.log('[Push] Subscription saved');
  }

  listenToClicks(): void {
    this.swPush.notificationClicks.subscribe(({ notification }) => {
      const url = notification.data?.url;

      if (url) {
        window.open(url, '_self');
      }
    });
  }
}
